export function formatLink(link) {
  if (!link) return '#';
  const trimmed = link.trim();

  // If it already has a protocol or starts with /, #, or ?, return as is
  if (trimmed.match(/^(http|https|mailto|tel):/i) || trimmed.startsWith('/') || trimmed.startsWith('#') || trimmed.startsWith('?')) {
    return trimmed;
  }

  // Check if it looks like an email
  if (trimmed.includes('@') && !trimmed.includes('/')) {
    return `mailto:${trimmed}`;
  }

  // Check if it looks like a phone number (mostly digits, dashes, spaces, parens, maybe a leading +)
  // We need to ensure it has enough digits to be a phone number and not just an arbitrary string
  const digits = trimmed.replace(/\D/g, '');
  const looksLikePhone = /^[+()\s\-\d]+$/.test(trimmed) && digits.length >= 7;

  if (looksLikePhone) {
    return `tel:${trimmed}`;
  }

  // Default fallback (e.g. they typed 'about' instead of '/about')
  // We assume relative paths if it doesn't match above, but typically they should start with /
  return trimmed;
}